import { z } from "zod";
export const Order = z.object({
    order: z.union([z.literal("asc"), z.literal("desc")]).default("asc"),
});
//# sourceMappingURL=order.js.map